import styled from "styled-components/macro";
import { media } from "../../utils";

export const LeadTitle = styled.span(({ theme }) => ({
  color: theme.color.neutral["03"],
}));

export const PassoImageMobile = styled.div({
  padding: " 0 20px",
  width: "100%",
  maxWidth: "120px",
  [media.md()]: {
    display: "none",
  },
});

export const PassoContent = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.color.neutral["04"]};
  margin-bottom: 32px;
  padding-bottom: 16px;
`;

export const PassosContainer = styled.div(({ linhaInversa }) => ({
  [`${PassoContent}:nth-of-type(${linhaInversa})`]: {
    flexDirection: "row-reverse",
    [media.lg()]: {
      display: "block",
    },
  },
}));
